import { render, staticRenderFns } from "./PembagianKelas.vue?vue&type=template&id=773b2a25"
import script from "./PembagianKelas.vue?vue&type=script&lang=js"
export * from "./PembagianKelas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports